import { render, staticRenderFns } from "./CentralCadastro.vue?vue&type=template&id=5c4273ef&scoped=true&"
import script from "./CentralCadastro.vue?vue&type=script&lang=js&"
export * from "./CentralCadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4273ef",
  null
  
)

export default component.exports